// import { ScreenContext } from '@/contexts/ScreenContext';
// import { useRwdUI } from '@/hooks/useRwdUI';
import { BetRecord } from '@/modules/report/slice/betSummary';
// import { getVHByRem } from '@/utils/commonFunc';
import { AmountText } from '@/utils/formatter';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
// import { useWindowSize } from '@react-hook/window-size';
import {
    // useContext,
    useEffect,
    useState,
} from 'react';
import { useTranslation } from 'react-i18next';

// import AutoSizer from 'react-virtualized-auto-sizer';
// import { FixedSizeList } from 'react-window';
// import { ReportDivider } from '../../../ReportDivider';
import { GetBetTypeToString } from '../../util';
import '../index.scss';

// const BET_ITEM_NUM = 4;

type BetContentProps = {
    betRecords: Array<BetRecord>;
    gameType: number;
    totalBetAmount: number;
    totalWinLoss: number;
    onGoing: boolean;
    result: string; //For BJ use
};
export const BetContent = (props: BetContentProps) => {
    const { t } = useTranslation();

    // const { pxToRwdNumber } = useRwdUI();
    // const [width, height] = useWindowSize({ wait: 100 });
    // const { isLandscape, scaleFactor } = useContext(ScreenContext);
    const {
        betRecords,
        gameType,
        totalBetAmount,
        totalWinLoss,
        onGoing,
        result,
    } = props;

    // const [itemHeight, setItemHeight] = useState(1);

    // useEffect(() => {
    //     setItemHeight(pxToRwdNumber(isLandscape ? 120 : 60));
    // }, [width, height, isLandscape, betRecords, scaleFactor]);

    const [betContentList, setBetContentList] = useState(<></>);
    // const [contentHeight, setContentHeight] = useState(0);

    useEffect(() => {
        if (betRecords && betRecords.length > 0) {
            setBetContentList(
                <>
                    {betRecords.map((rec, index) => (
                        <div key={`bet-record-${index}-${rec.GameID}`}>
                            <BetContentItem
                                record={rec}
                                gameType={gameType}
                                onGoing={onGoing}
                                result={result}
                            />
                            {index !== betRecords.length - 1 && (
                                <div className="bet-content-divider" />
                            )}
                        </div>
                    ))}
                </>
            );
            // setBetContentList(
            //     <AutoSizer>
            //         {({ width, height }) => (
            //             <FixedSizeList
            //                 className="hide-scrollbar"
            //                 height={height}
            //                 width={width}
            //                 itemCount={betRecords.length}
            //                 itemSize={itemHeight}
            //                 itemData={betRecords}
            //                 itemKey={(index, data) =>
            //                     `bet-record-${index}-${data[index].GameID}`
            //                 }
            //             >
            //                 {({ index, style, data }) => (
            //                     <div
            //                         style={{
            //                             ...style,
            //                             height: itemHeight,
            //                         }}
            //                     >
            //                         <BetContentItem
            //                             record={data[index]}
            //                             gameType={gameType}
            //                             onGoing={onGoing}
            //                             result={result}
            //                         />
            //                     </div>
            //                 )}
            //             </FixedSizeList>
            //         )}
            //     </AutoSizer>
            // );
            // setContentHeight(
            //     itemHeight * Math.min(betRecords.length, BET_ITEM_NUM)
            // );
        }
        // else {
        //     setBetContentList(
        //         <Grid
        //             item
        //             container
        //             justifyContent="center"
        //             sx={{
        //                 // margin: '0 0 1rem 0',
        //                 fontSize: isLandscape ? getVHByRem(1) : '1rem',
        //             }}
        //         >
        //             {t('betlog.noRecord')}
        //         </Grid>
        //     );
        //     setContentHeight(0);
        // }
    }, [betRecords /*, itemHeight*/]);

    return (
        <Box className="bet-content-container">
            <Grid container className="bet-content-header">
                <Grid item className="bet-content-header-item bet-type">
                    <span>{t('betlog.bet_type')}</span>
                    <span>{t('betlog.betId')}</span>
                </Grid>
                <Grid item className="bet-content-header-item bet-amount">
                    {t('betlog.bet_amount')}
                </Grid>
                <Grid item className="bet-content-header-item winlose">
                    {t('betlog.win_lose')}
                </Grid>
            </Grid>
            <div className="bet-content-list hide-scrollbar">
                {betContentList}
            </div>
            {/* <Box height={contentHeight}>{betContentList}</Box> */}
            {/* Summary */}
            <div className="bet-content-item-container-wrapper summary bet-content-divider bold">
                <Grid container className="bet-content-item-container">
                    <Grid item className="bet-content-item bet-type">
                        <span className="total-bet-amount">
                            {t('betlog.total')}
                        </span>
                    </Grid>
                    <Grid item className="bet-content-item bet-amount bold">
                        {totalBetAmount && (
                            <AmountText
                                amount={totalBetAmount / 100}
                                textAlign={'end'}
                                with_color={false}
                                with_sign={false}
                            />
                        )}
                    </Grid>
                    <Grid item className="bet-content-item winlose bold">
                        {!onGoing && (
                            <AmountText
                                amount={totalWinLoss / 100}
                                textAlign={'end'}
                                with_color={true}
                                with_sign={true}
                                zero_white_no_sign={true}
                            />
                        )}
                        {onGoing && <></>}
                    </Grid>
                </Grid>
            </div>
        </Box>
    );
};

type BetContentItemProps = {
    record: BetRecord;
    gameType: number;
    onGoing: boolean;
    result: string; //For BJ Use
};

const BetContentItem = (props: BetContentItemProps) => {
    const { record, gameType, onGoing, result } = props;

    return (
        <div className="bet-content-item-container-wrapper">
            <Grid container className="bet-content-item-container">
                <Grid item className="bet-content-item bet-type">
                    <span>
                        {GetBetTypeToString(gameType, record.BetType, result)}
                    </span>
                    <span className="bet-id">{record.BetID}</span>
                </Grid>
                <Grid item className="bet-content-item bet-amount">
                    <AmountText
                        amount={record.BetAmount / 100}
                        textAlign={'end'}
                        with_color={false}
                        with_sign={false}
                    />
                </Grid>
                <Grid item className="bet-content-item winlose">
                    {!onGoing && (
                        <AmountText
                            amount={record.ResultAmount / 100}
                            textAlign={'end'}
                            with_color={true}
                            with_sign={true}
                            zero_white_no_sign={true}
                        />
                    )}
                    {onGoing && <></>}
                </Grid>
            </Grid>
            {/* <ReportDivider isCell={true} /> */}
        </div>
    );
};
